<template>
  <div class="flex-shrink-2 ml-1" v-if="hasSettings || hasAnyAccess">
    <div class="dropdown">
      <i class="fas fa-ellipsis-v cursor-pointer" data-toggle="dropdown" aria-expanded="false"></i>
      <div class="dropdown-menu">
        <component
            v-for="setting in settings"
            :key="setting.event"
            :message="message"
            :url="setting.formData"
            v-bind:is="setting.component"
            v-if="inAvailableType(setting) && hasAccess(setting)"
        >
        </component>
      </div>
    </div>
  </div>
</template>

<script>
import TogglePreserve from './settings/toggle-preserve';
import MessageEdit from './settings/message-edit';
import MessageMarkUnread from './settings/message-mark-unread';
import ScheduleMessageDelete from './settings/schedule/delete';
import ScheduleMessageForceSend from './settings/schedule/force-send';
import ReplyTo from './settings/reply-to';
import OriginalEmailMessage from './settings/original-email-message';

export default {
  components: {
    'toggle-preserve': TogglePreserve,
    'message-edit': MessageEdit,
    'message-mark-unread': MessageMarkUnread,
    'schedule-message-delete': ScheduleMessageDelete,
    'schedule-message-force-send': ScheduleMessageForceSend,
    'reply-to': ReplyTo,
    'original-email-message': OriginalEmailMessage,
  },

  props: {
    settings: Array,
    message: Object,
  },

  computed: {
    /**
     * @return {boolean}
     */
    hasSettings() {
      return !_.isEmpty(this.settings) && !_.isEmpty(this.hasAnyAccess);
    },

    /**
     * @return {boolean}
     */
    hasAnyAccess() {
      let access = _.filter(this.settings, (setting) => {
        return this.hasAccess(setting) && this.inAvailableType(setting);
      });

      return !_.isEmpty(access);
    },
  },

  methods: {
    /**
     * @param {Object} setting
     * @return {boolean}
     */
    inAvailableType(setting) {
      const list = _.get(setting, 'includedTypes', []);
      if (_.isEmpty(list)) {
        return true;
      }

      return _.includes(list, _.get(this.message, 'type'));
    },

    /**
     * @param {Object} setting
     * @return {boolean}
     */
    hasAccess(setting) {
      return _.get(setting, 'userCan', false);
    },
  },
}
</script>
